import { Box } from "@mui/material";
import { styled } from "@mui/system";

const StyledWrapper = styled(Box)(({ theme }) => ({
  width: "100%",
  padding: "clamp(28px, 4.5vw, 72px) 0",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  ".information-container": {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexWrap: "wrap",
    gap: "clamp(24px, 6vw, 110px)",
  },
  ".information-box": {
    display: "flex",
    alignItems: "center",
    gap: "clamp(8px, 0.8vw, 14px)",
  },
  ".information-animated-box": {
    backgroundColor: theme.palette.primary.main,
    color: "#fff",
    fontFamily: "Inter",
    fontWeight: 900,
    fontSize: "clamp(20px, 2.5vw, 48px)",
    lineHeight: 1,
    padding: "0.18em 0.4em",
    borderRadius: "6px",
    letterSpacing: "-0.02em",
    minWidth: "1.3em",
    textAlign: "center",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
  },
  ".information-label": {
    fontFamily: "Inter",
    fontWeight: 700,
    fontSize: "clamp(20px, 2.5vw, 48px)",
    lineHeight: 1,
    color: theme.palette.primary.main,
    letterSpacing: "-0.02em",
    textTransform: "lowercase",
  },
}));

export default StyledWrapper;
